import { FC } from 'react';

import { Box } from '@mui/material';
import { ISubscriptionPlanLayoutProps } from 'layouts/SubscriptionPlansLayout/types';

export const SubscriptionPlansDesktopView: FC<ISubscriptionPlanLayoutProps> = ({ children }) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'} gap="24px" alignItems={'stretch'}>
      {children}
    </Box>
  );
};
